import { QUERY_GET_FACTORY_OFFICES_BY_CITY, QUERY_GET_FACTORY_OFFICES_BY_PROVINCE } from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const getFactoryOfficesByProvinceId = baseThunk(`factoryOffices/getOfficesByProvinceId`, QUERY_GET_FACTORY_OFFICES_BY_PROVINCE, "GET");
export const getFactoryOfficesByCityId = baseThunk(`factoryOffices/getOfficesByCityId`, QUERY_GET_FACTORY_OFFICES_BY_CITY, "GET");